<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'《新仙剑奇侠传之挥剑问情》手游下载'"></div>
    <div :class="'home-bank-page page-' + pageShow + ' os-' + typeOs">
      <div class="exit" @click="exitLogin()"></div>
      <div class="bank-banner">
        <div class="bank-info">
          <dl>
            <dt>
              <h3>欢迎你,{{ bank_name }}</h3>
              <h2>当前排名：<span>{{ my_rank }}</span></h2>
            </dt>
            <dd>
              <strong class="zc-info">{{ register_num }}</strong>
              <strong class="zl-info">{{ my_bank_fap }}</strong>
              <strong class="hy-info">{{ activity_num }}</strong>
            </dd>
          </dl>
        </div>
        <div :class="'btn-all btn-all-' + is_status">
          <a class="share-btn" href="javascript:;" @click="openShare()"></a>
          <a class="download-btn" href="javascript:;" @click="jumpDownLoad()"></a>
        </div>
        <div class="prompt" @click="openPrompt()">
          <p>※请使用<span>官方渠道</span>下载游戏,其他渠道参与活动则被视为无效<i></i></p>
        </div>
      </div>
      <div class="search-content">
        <div class="search">
          <label for=""><input v-model="accountVal" type="text" placeholder="输入手机号码"
              :onkeyup="accountVal = accountVal.replace(/[\u4e00-\u9fa5 ]/g, '')"></label>
          <a href="javascript:;" @click="searchAccount();"></a>
        </div>
        <div class="search-info" v-show="searchInfoShow">
          <div class="phone">{{ searchData.account }}</div>
          <div class="name">{{ searchData.role_name }}</div>
          <div class="capacity">{{ searchData.fap }}</div>
          <div class="confirm-btn" @click="closeSearch()"></div>
        </div>
      </div>
      <div class="ranking-content-all">
        <div :class="'rabking-title rabking-title-' + rabkingTabType">
          <a class="zph-btn" href="javascript:;" @click="rabkingTab(1)"></a>
          <a class="grb-btn" href="javascript:;" @click="rabkingTab(2)"></a>
        </div>
        <div class="overall-ranking-content" v-show="overallShow">
          <h2 class="title"></h2>
          <div class="ranking">
            <ul class="top-list">
              <li :class="'top-' + Number(index + 1)" v-for="(item, index) in total_fap.slice(0, 3)">
                <h3>{{ item.bank_name }}</h3>
                <div>总战力<br /><span>{{ item.fap }}</span></div>
              </li>
              <li class="top-1" v-if="total_fap.length < 1">
                <h3>虚席以待</h3>
                <div>总战力:<br /><span>-</span></div>
              </li>
              <li class="top-2" v-if="total_fap.length < 2">
                <h3>虚席以待</h3>
                <div>总战力:<br /><span>-</span></div>
              </li>
              <li class="top-3" v-if="total_fap.length < 3">
                <h3>虚席以待</h3>
                <div>总战力:<br /><span>-</span></div>
              </li>
            </ul>
            <ul class="other-list">
              <li :class="'li-' + Number(index + 1)" v-for="(item, index) in total_fap">
                <i>{{ Number(index + 1) }}</i>
                <h3>{{ item.bank_name }}</h3>
                <h4>总战力:{{ item.fap }}</h4>
              </li>
            </ul>
          </div>
        </div>
        <div class="personal-ranking-content" v-show="personalShow">
          <h2 class="title"></h2>
          <h5>
            <p>个人榜排行每日08:00刷新</p>
          </h5>
          <ul class="other-list">
            <li :class="'li-' + Number(index + 1)" v-for="(item, index) in rank.slice(0, 10)">
              <i>{{ Number(index + 1) }}</i>
              <h3>{{ item.account }}</h3>
              <h4>总战力:{{ item.fap }}</h4>
            </li>
          </ul>
        </div>
      </div>
      <!-- 公共底部 -->
      <Footer />
    </div>

    <!-- 分享相关DOM -->
    <div :class="'share-box share-box-' + pageShow" ref="imageDom">
      <img src="https://download4.qcplay.com/h5-images/active/hjwq/bank/code_img.png" />
      <div class="share-img">
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>
    <!-- 提示弹窗 -->
    <div class="prompt-popup popup_wrap" v-show="promptShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="prompt-box popup_wrap-box" v-show="promptShow">
          <div class="close-btn" @click="promptShow = false"></div>
        </div>
      </transition>
    </div>
    <!-- 分享弹窗 -->
    <div class="share-popup popup_wrap" v-show="shareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="share-box-2 popup_wrap-box" v-show="shareShow">
          <img :src="shareImg">
          <div class="close-btn" @click="shareClose()"></div>
          <div class="bottom-btn">
            <a id="my-code" href="javascript:;" @click="onCopy('#my-code')"
              :data-clipboard-text='"《新仙剑奇侠传之挥剑问情》邀您重温经典：" + urlCode'></a>
            <span :class="'tip-' + typeOs"></span>
          </div>
        </div>
      </transition>
    </div>
    <!-- 提示弹窗 -->
    <div :class="'tips-wrap tips-wrap-' + tipsShow">
      <div :class="'show-' + tipsShow2">
        <p>{{ tips }}</p>
      </div>
    </div>
  </div>

</template>
<script>
import Footer from '../../../../components/BankFooter';
import { Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { getRandomString, monitoringOs, buriedLogger } from '@/utils/utils';
import { OnGetInitDataAPI, ExitAPI } from '../api';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
export default {
  components: {
    Footer
  },
  data() {
    return {
      pageShow: false,
      promptShow: false,
      shareShow: false,
      shareImg: 'https://download4.qcplay.com/h5-images/active/hjwq/bank/code_img.png',
      is_shareImg: '',
      urlCode: '',
      // 当前总战力
      my_bank_fap: '0',
      // 注册账号
      register_num: '0',
      // 当前排名
      my_rank: '1',
      // 今日活跃
      activity_num: '0',
      // 个人排行榜
      rank: [],
      // 搜索到的信息
      searchData: {
        account: "",
        fap: "",
        role_name: ""
      },
      // 总排名列表
      total_fap: '',
      // 银行名称
      bank_name: '尊敬的用户',
      // 搜索用的账号
      accountVal: '',
      // 搜索显示框
      searchInfoShow: false,
      // 当前设备
      typeOs: '',
      rabkingTabType: 1,
      overallShow: true,
      personalShow: false,
      is_status: 1,

      // 提示弹窗
      tips: '', // 提示语
      tipsShow: false,  // 提示显示1
      tipsShow2: false, // 提示显示2
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 当前设备
      this.typeOs = monitoringOs();
      if (this.typeOs == 'ios' || this.typeOs == 'android') {
        this.overallShow = true;
        this.personalShow = true;
      }
    })
    setTimeout(() => {
      OnGetInitDataAPI().then(response => {
        if (Number(response.code) == 200) {
          const { origin } = window.location;
          this.activity_num = response.data.activity_num;
          this.my_bank_fap = response.data.my_bank_fap;
          this.rank = response.data.rank.data;
          this.bank_name = response.data.name;
          this.register_num = response.data.register_num;
          this.my_rank = response.data.my_rank;
          this.total_fap = response.data.total_fap;
          this.is_status = response.data.is_status;
          this.urlCode = `${origin}/hjwq/bank/download${getRandomString()}?code=${response.data.code}`
          this.pageShow = true;
          // 二维码生成
          setTimeout(() => {
            this.qrcode(this.urlCode);
            this.$nextTick(() => {
              this.generateShareImage();
            });
          }, 200)
        }
        // 登录失败重定向
        if (Number(response.code) == 302) {
          const { origin } = window.location;
          window.location.href = origin + '/hjwq/bank' + response.data.uri;
          // this.pageShow = true;
        }
      });
    }, 200);

    // 埋点
    const bl = buriedLogger('hjwq', 'bank_index_page');
    this.logger = bl;

    setTimeout(() => {
      this.logger.sum('银行挑战赛h5_活动页统计');
    }, 200);
  },
  computed: {},
  methods: {
    // 开启提示弹窗
    openShare() {
      this.shareImg = this.is_shareImg;
      this.shareShow = true;
      this.logger.sum('银行挑战赛h5_点击分享游戏按钮');
    },
    // 关闭分享弹窗
    shareClose() {
      this.shareImg = '';
      this.shareShow = false;
    },
    // 点击查看提示
    openPrompt() {
      this.promptShow = true;
      this.logger.sum('银行挑战赛h5_点击提示按钮');
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          Indicator.close();
          this.is_shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
        });
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#faf2de',
        colorLight: '#d6605e'
      });
    },
    // 复制链接
    onCopy(my_id) {
      const clipboard = new Clipboard(my_id);
      clipboard.on('success', (e) => {
        this.tipsMessage('复制成功', 1000);
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.tipsMessage('复制失败', 1000);
      });
      this.logger.sum('银行挑战赛h5_复制链接按钮');
    },
    // 退出登录
    exitLogin() {
      Indicator.open();
      ExitAPI().then(response => {
        if (Number(response.code) == 200) {
          window.location.href = `login${getRandomString()}`;
          this.logger.sum('银行挑战赛h5_用户点击账户退出按钮');
        }
        this.tipsMessage(response.message, 1000);
        Indicator.close();
      });
    },
    // 请问下载页面
    jumpDownLoad() {
      this.logger.sum('银行挑战赛h5_点击右侧下载游戏按钮');
      this.tipsMessage('正在前往...', 1000);
      setTimeout(() => {
        window.location.href = this.urlCode;
      }, 1000)
    },
    // 搜索手机号码
    searchAccount() {
      if (this.accountVal == '') {
        this.tipsMessage('请输入搜索的手机号码', 1000);
        return
      }
      Indicator.open();
      OnGetInitDataAPI({ account: this.accountVal }).then(response => {
        if (Number(response.code) == 200) {
          this.searchInfoShow = true;
          this.searchData = response.data.search;
          this.logger.sum('银行挑战赛h5_号码搜索统计');
        }
        // 登录失败重定向
        if (Number(response.code) == 302) {
          const { origin } = window.location;
          window.location.href = origin + '/hjwq/bank' + response.data.uri;
        }
        if (Number(response.code) == 401) {
          this.searchInfoShow = false;
        }
        Indicator.close();
        this.tipsMessage(response.message, 1000);
      });
    },
    // 关闭搜索按钮
    closeSearch() {
      this.searchInfoShow = false;
      this.searchData = '';
      this.accountVal = '';
    },
    // 排行切换
    rabkingTab(i) {
      this.rabkingTabType = i;
      if (i == 1) {
        this.overallShow = true;
        this.personalShow = false;
      } else {
        this.overallShow = false;
        this.personalShow = true;
      }
    },
    // TAG: 其他简易封装的方法
    tipsMessage(message, times) {
      this.tipsShow = true
      this.tips = message
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = ''; }, times)
    },
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/bank/index/index.vue